import styled, { css } from 'styled-components';

import { ButtonContainer } from 'libs/ui';
import { WhiteStyledField } from 'libs/form';

export const TextareaStyledField = styled(WhiteStyledField)`
  height: 80px;
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 9px 4px;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      textarea {
        background-color: transparent;
        color: #f0f0f0;
      }
    `}
`;

export const StyledButtonContainer = styled(ButtonContainer)`
  margin-top: 20px;
  justify-content: flex-end;
`;
